import TvanHandleApi from 'api/TvanHandleApi'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import ToastHelper from 'general/helpers/ToastHelper'
import { memo, useCallback, useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import { Typography } from 'antd'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import * as Yup from 'yup'
import { REGEX_TVAN_MESSAGE } from 'general/constants/AppRegex'
import CustomLabel from 'general/components/CustomLabel'
import CustomSelect from 'general/components/CustomSelect'
import SelectOptions from 'general/constants/SelectOptions'
import { FormLabel } from 'react-bootstrap'
import TextArea from 'antd/es/input/TextArea'
const ModalEditRegistration = ({
  modalsState,
  setModalsState,
  refetchList,
}) => {
  const [dataConfix, setDataConfix] = useState(modalsState?.data)

  useEffect(() => {
    if (modalsState?.show) {
      setDataConfix(modalsState?.data)
    } else {
      setDataConfix({})
    }
  }, [modalsState?.show])

  const update = async (dataConfix) => {
    // Your logic to move to send invoice goes here
    // For example, you can call an API endpoint to move to send invoice
    // await sendInvoiceToHandler(payload)
    console.log('dataConfix', dataConfix)
    let check = false
    if (!dataConfix?.status) {
      ToastHelper.showError('Vui lòng chọn trạng thái tờ khai')
      check = true
    }
    if (!dataConfix?.reason) {
      ToastHelper.showError('Vui nhập lý do thay đổi tờ khai')
      check = true
    }
    if (check) return
    try {
      const { result, message } = await TvanHandleApi.updateRegisAdmin({
        registrationId: dataConfix?.registrationId,
        status: dataConfix?.status,
        reason: dataConfix?.reason,
        type: 'editStatus',
      })
      if (result === 'success') {
        ToastHelper.showSuccess('Cập nhật tờ khai thành công')

        refetchList()
        setModalsState({ show: false, data: {} })
      } else {
        ToastHelper.error('Lỗi nội bộ máy chủ')
      }
    } catch (error) {
      console.error('Occured error at update function: ' + error)
    }
  }
  console.log('modalsState', modalsState)

  return (
    <>
      <ModalConfirm
        header="Chỉnh sửa trạng thái tờ khai"
        submitNotClose={1}
        content={
          <>
            <div className="flex-row">
              <div>
                <FormLabel fontWeight="600">
                  Trạng thái <span className="text-danger">(*)</span>
                </FormLabel>
              </div>
              <div>
                <CustomSelect
                  selectOptions={SelectOptions.registrationStatus}
                  currentValue={dataConfix?.status}
                  defaultValue={dataConfix?.status}
                  onChange={(selectedOption) => {
                    setDataConfix({
                      ...dataConfix,
                      status: selectedOption?.value,
                    })
                  }}
                  haveMenuParentRef={false}
                  width="100%"
                />
              </div>
              <br></br>
              <div>
                <FormLabel fontWeight="600">
                  Lý do <span className="text-danger">(*)</span>
                </FormLabel>
              </div>
              <div>
                <TextArea
                  value={dataConfix?.reason}
                  showCount
                  maxLength={300}
                  onChange={(e) => {
                    setDataConfix({
                      ...dataConfix,
                      reason: e?.target?.value,
                    })
                  }}
                  placeholder="Nhập lý do không vượt quá 300 ký tự"
                  style={{ height: 120, resize: 'none' }}
                />
              </div>
            </div>
          </>
        }
        show={modalsState.show}
        setShow={(status) => setModalsState({ ...modalsState, show: status })}
        handleConfirm={(e) => {
          update(dataConfix)
          // e.preventDefault()
          // moveToSendErrorHandler({ invoiceId: tvanState.activeRow?.invoiceId })
          // setModalsState({ key: 'moveStatusModal', value: false })
        }}
      />
    </>
  )
}
export default memo(ModalEditRegistration)
